import { render, staticRenderFns } from "./chartSerial.vue?vue&type=template&id=b643c102&"
import script from "./chartSerial.vue?vue&type=script&lang=js&"
export * from "./chartSerial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports